import { Routes } from '@angular/router';
import { SiteAuditComponent } from '@app/features/site-audit/site-audit.component';
import { Authority } from '@app/shared/utils/enums';

export const siteAuditRoutes: Routes = [
    {
        path: 'site-audit',
        children: [
            {
                path: '',
                component: SiteAuditComponent,
                data: {
                    authorities: [Authority.ADMIN]
                }
            }
        ]
    }
]